module.exports = "<div class=\"centerVert notification-usr\">\n    <i class=\"icon icon-3x icon-white icon-activity\"></i>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./scripts/directives/dashboard/header/user-events/user-events.html
// module id = erZH
// module chunks = 0